import React from 'react'
function AboutFour() {
    return (
        <div>
            {/* rts about area start */}
            <div className="rts-about-area rts-section-gap about-home-seven">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="thumbnail">
                                <img src={`${process.env.PUBLIC_URL}/assets/images/about/main/06.jpg`} alt="about_image" />
                                <img
                                    src={`${process.env.PUBLIC_URL}/assets/images/about/main/about-02-sm.jpg`}
                                    alt="small"
                                    className="small"
                                />
                                <div className="experience-area six">
                                    <h2 className="title">25</h2>
                                    <span>Years Of Experience</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="text-start home-seven-about">
                                <p className="pre-title">More About Finbiz</p>
                                <h3 className="title">
                                    Our Consulting For All Kind Of Finance Services
                                </h3>
                            </div>
                            <div className="inner-about-home-7">
                                <p className="disc">
                                    Molestie velit imperdiet porttitor at taciti, aptent semper primis
                                    nisl ut. Inceptos velit penatibus tortor in sed curae urna
                                    lobortis ultricies aptent integer bibendum parturient molestie
                                    risus
                                </p>
                                {/* ingle about start */}
                                <div className="about-single-home-7">
                                    <div className="icon">
                                        <img src={`${process.env.PUBLIC_URL}/assets/images/about/main/icon/01.svg`} alt="" />
                                    </div>
                                    <div className="discription">
                                        <h6 className="title">Global Insights</h6>
                                        <p className="disc">
                                            Aliquet bibendum duis diam ultricies rutrum vulputate, platea
                                            lacinia tortor mollis nam dis.
                                        </p>
                                    </div>
                                </div>
                                {/* ingle about end */}
                                {/* ingle about start */}
                                <div className="about-single-home-7">
                                    <div className="icon">
                                        <img src={`${process.env.PUBLIC_URL}/assets/images/about/main/icon/02.svg`} alt="" />
                                    </div>
                                    <div className="discription">
                                        <h6 className="title">Business Investment</h6>
                                        <p className="disc">
                                            Aliquet bibendum duis diam ultricies rutrum vulputate, platea
                                            lacinia tortor mollis nam dis.
                                        </p>
                                    </div>
                                </div>
                                {/* ingle about end */}
                                {/* ingle about start */}
                                <div className="about-single-home-7">
                                    <div className="icon">
                                        <img src={`${process.env.PUBLIC_URL}/assets/images/about/main/icon/03.svg`} alt="" />
                                    </div>
                                    <div className="discription">
                                        <h6 className="title">Yearly Calculation</h6>
                                        <p className="disc">
                                            Aliquet bibendum duis diam ultricies rutrum vulputate, platea
                                            lacinia tortor mollis nam dis.
                                        </p>
                                    </div>
                                </div>
                                {/* ingle about end */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* rts about area end */}
        </div>
    )
}

export default AboutFour